/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Dok_S5Inputs */

const en_tut_dok_s5 = /** @type {(inputs: Tut_Dok_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To write together, the owner presses **Aktifkan penyuntingan bersama**. After that changes save themselves, and **Simpan versi** creates a quick restore point.`)
};

const id_tut_dok_s5 = /** @type {(inputs: Tut_Dok_S5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untuk menulis bersama, pemilik menekan **Aktifkan penyuntingan bersama**. Setelah itu perubahan tersimpan otomatis, dan **Simpan versi** membuat titik pulihkan-cepat.`)
};

/**
* | output |
* | --- |
* | "To write together, the owner presses **Aktifkan penyuntingan bersama**. After that changes save themselves, and **Simpan versi** creates a quick restore point." |
*
* @param {Tut_Dok_S5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_dok_s5 = /** @type {((inputs?: Tut_Dok_S5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Dok_S5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_dok_s5(inputs)
	return en_tut_dok_s5(inputs)
});